import { useQuery } from '@tanstack/react-query';
import {
  GitLabApi,
  GitLabCIVariablesSearchRequest,
} from 'osep-generator-service-client-v1';
import { GITLAB_OSEP_PIPELINE_VARIABLE_QUERY_KEY } from '../../utils/consts';
import { useApiConfig } from '../useApiConfig';

function useGitlabOsepPipelineVariableSearchQuery(
  gitlabCIVariablesSearchRequest: GitLabCIVariablesSearchRequest,
) {
  const { getApiConfig, axiosInstance } = useApiConfig();

  return useQuery({
    queryKey: [
      [
        GITLAB_OSEP_PIPELINE_VARIABLE_QUERY_KEY,
        gitlabCIVariablesSearchRequest.ref,
      ],
      gitlabCIVariablesSearchRequest,
    ],
    queryFn: async () => {
      const config = await getApiConfig();
      const api = new GitLabApi(config, undefined, axiosInstance);

      const result = (
        await api.getGitlabPipelineVariables(gitlabCIVariablesSearchRequest)
      ).data;
      return result;
    },
  });
}

export default useGitlabOsepPipelineVariableSearchQuery;
